/* unplugin-vue-components disabled */import script from "./WechatRepoetDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WechatRepoetDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./WechatRepoetDetailModal.vue?vue&type=style&index=0&id=003f4c91&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003f4c91"]])

export default __exports__